import { JanusVideoObjectConfig } from '@/classes/JanusVideoObject'
import { VideoObjectConfig } from '@/classes/VideoObject'
import { SelfTestQuestionStep } from '../types'

interface getVideoConfigParams {
  streamUrl: string
  videoId: string
  chinaSupport?: boolean
  udpEnabled: boolean
}

export enum SelfTestStreamType {
  Remote = 'Remote',
  Local = 'Local'
}

export interface SelfTestQuestionInfo {
  type: SelfTestQuestionStep
  questionKey: string
  streamType: SelfTestStreamType
}

export const SelfTestQuestions: [number, SelfTestQuestionInfo][] = [
  [0, { type: SelfTestQuestionStep.SEE_STEAM,
    questionKey: 'selftest_canyouseeremote_question', streamType: SelfTestStreamType.Remote }],
  [1, { type: SelfTestQuestionStep.HEAR_STEAM,
    questionKey: 'selftest_canyouhearremote_question', streamType: SelfTestStreamType.Remote }],
  [2, { type: SelfTestQuestionStep.SEE_YOURSELF,
    questionKey: 'selftest_canyouseelocal_question', streamType: SelfTestStreamType.Local }],
  [3, { type: SelfTestQuestionStep.HEAR_YOURSELF,
    questionKey: 'selftest_canyouhearlocal_question', streamType: SelfTestStreamType.Local }]
]

export const getVideoConfig = ({
  streamUrl,
  videoId,
  chinaSupport = false,
  udpEnabled }: getVideoConfigParams, isJanus = false) => {
  const data = {
    id: videoId,
    chinaSupport,
    name: videoId,
    streamToPlay: { url: streamUrl },
    logNetwork: true,
    udpEnabled,
    callback: () => {},
    killStream: () => {},
    restartStream: () => {}
  }
  if (isJanus) {
    const config: JanusVideoObjectConfig = {
      ...data,
      url: streamUrl
    }
    return config
  } else {
    const config: VideoObjectConfig = {
      ...data
    }
    return config
  }
}

type pendingCallBack = () => void
export const checkPendingTime = (limit: number, callBack: pendingCallBack): ReturnType<typeof setInterval> => {
  let wait = 0
  const waitInterval = setInterval(() => {
    if (wait > limit) {
      callBack()
      clearInterval(waitInterval)
    }
    wait++
  }, 1000)
  return waitInterval
}
